import React, { useState } from "react";
import { Badge, Dropdown, Modal } from "react-bootstrap";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import Button from "../sharedComponents/buttons/button";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import {
  getAllAssignmentCommentsAPI,
  getAssignmentAPI,
} from "../../API/store/actions/PresidentialAssignmenty";
import { useDispatch, useSelector } from "react-redux";
import { paths } from "../../paths/paths";
import { styleEnd } from "../../algorithms/styleDirection";
import { useNavigate } from "react-router-dom";

const AssignmentCard = ({
  assignment,
  onAddResponse,
  onEdit,
  onDelete,
  onAddDirective,
}) => {
  const [deleting, setDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showResponses, setShowResponses] = useState(false);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const navigate = useNavigate();
  const userToken = useSelector((state) => state.login.userToken);
  const dispatch = useDispatch();
  const handleDelete = async () => {
    if (!deleteId) return;

    setDeleting(true);

    try {
      await onDelete(deleteId);

      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
    } finally {
      setDeleting(false);
    }
  };
  const handleShowResponses = async () => {
    const nextValue = !showResponses;
    setShowResponses(nextValue);

    // Don't call API again if already loaded
    if (!nextValue || comments.length > 0) return;

    setCommentsLoading(true);

    try {
      const action = await getAllAssignmentCommentsAPI(
        assignment.id,
        userToken,
      );

      const result = await dispatch(action);

      setComments(result?.payload?.data || []);
    } finally {
      setCommentsLoading(false);
    }
  };

  const ThreeDotsToggle = React.forwardRef(({ onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      style={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        cursor: "pointer",
      }}
      className="d-flex justify-content-center align-items-center hover-bg-light"
    >
      <Icon name="ellipsis-v" size={18} color="#6c757d" />
    </div>
  ));

  ThreeDotsToggle.displayName = "ThreeDotsToggle";
  const formatDate = (date) => {
    if (!date) return "";

    return new Intl.DateTimeFormat("ar-EG", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(date));
  };
  return (
    <div
      className="card shadow-sm mb-4 w-100 "
      style={{
        borderRadius: 12,
        border: "1px solid #e5e5e5",
      }}
    >
      <div className="card-body">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start ">
          <div className="d-flex ">
            <p
              className="mb-0 fs-5 fw-bold"
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(`/presidential-assignments-directive/${assignment.id}`)
              }
            >
              {assignment.titleA}
            </p>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Dropdown align="end">
              <Dropdown.Toggle as={ThreeDotsToggle} />

              <Dropdown.Menu
                style={{
                  borderRadius: 10,
                  minWidth: 180,
                  boxShadow: "0 4px 12px rgba(0,0,0,.15)",
                }}
              >
                <Dropdown.Item
                  onClick={async () => {
                    const action = await getAssignmentAPI(
                      assignment?.id,
                      userToken,
                    );

                    await dispatch(action);
                    onEdit();
                  }}
                  className="d-flex align-items-center"
                >
                  <Icon name="edit" size={15} color="#0C574C" />
                  <span className="mx-2">تعديل التكليف</span>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={async () => {
                    // const action = await getAssignmentAPI(
                    //   assignment?.id,
                    //   userToken,
                    // );
                    // await dispatch(action);
                    // navigate(
                    //   `/presidential-assignments-directive/${assignment?.id}`,
                    // );
                    onAddDirective();
                  }}
                  className="d-flex align-items-center"
                >
                  <Icon name="plus" size={15} color="#0C574C" />
                  <span className="mx-2">إضافة توجيه رئاسي </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="mb-3"></div>
        <div className="d-flex gap-5">
          <h6 className="mb-1">رقم التكليف : {assignment.id}</h6>
          <small className="text-muted d-block">
            تاريخ البدء: {formatDate(assignment.startDate)}
          </small>
          <small className="text-muted d-block">
            تاريخ الانتهاء: {formatDate(assignment.endDate)}
          </small>
        </div>
        {/* Members */}
        <div className="my-3">
          <h6>الجهات</h6>

          <div className="d-flex flex-wrap align-items-center gap-2">
            {assignment.adminmember && (
              <span
                className="rounded-pill text-dark px-3 py-1"
                style={{ backgroundColor: "#f2f2f2" }}
              >
                {assignment.adminmember.memberName}
              </span>
            )}

            {assignment.member?.map((member) => (
              <span key={member.id} className="badge rounded-pill text-dark">
                {member.memberName}
              </span>
            ))}
          </div>
        </div>
        <div className="col-md-12 mb-3">
          <div className="text-muted mb-2">المرفقات</div>

          {assignment.attchment?.length > 0 ? (
            <div className="d-flex  gap-2">
              {assignment.attchment.map((file) => (
                <a
                  key={file.id}
                  href={`${paths.PresidentialTask}${assignment.id}/${file.attachment}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-dark d-flex gap-2"
                >
                  <Icon name="paperclip" size={14} />
                  <span className="mx-2">{file.attachment}</span>
                </a>
              ))}
            </div>
          ) : (
            <span className="text-muted">لا يوجد</span>
          )}
        </div>
        {/* Actions */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 ">
          <div className="d-flex  flex-row  col-10">
            <Button
              containerStyle={"col-6 col-md-1"}
              buttonStyleType="solid"
              customStyle={{ fontSize: 14, minWidth: 80, height: 35 }}
              size="sm"
              onClick={handleShowResponses}
              content={showResponses ? "إخفاء الردود" : "عرض الردود"}
            />
          </div>
          <div
            className="d-flex align-items-center align-self-md-auto"
            onClick={() => onAddResponse(assignment)}
            style={{ cursor: "pointer" }}
          >
            <div
              style={{
                backgroundColor: "#0c574b",
                height: 26,
                width: 26,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center align-items-center plusIcon"
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  background:
                    "url('/assets/images/icons/Path 184.png') center/contain no-repeat",
                  filter: "brightness(20)",
                }}
              />
            </div>

            <span className="mx-2">{Lang.addResponse}</span>
          </div>
        </div>
        {/* Responses */}
        {showResponses && (
          <div className="mt-4">
            {commentsLoading ? (
              <div className="text-center py-3">
                <div className="spinner-border spinner-border-sm" />
              </div>
            ) : comments.length ? (
              comments.map((comment) => {
                // const attachmentUrl = `${import.meta.env.VITE_API_BASE_URL}/uploads/${comment.attachment}`;

                return (
                  <div key={comment.id} className="border rounded p-3 mb-2">
                    <div className="d-flex justify-content-between">
                      <div className="text-muted">{comment.userName}</div>

                      <small className="text-muted">
                        {formatDate(comment.createDate)}
                      </small>
                    </div>

                    <strong className="mt-1 fs-6">{comment.description}</strong>
                    {comment.attachment && (
                      <div className="mt-1">
                        <a
                          href={`${paths.PresidentialTaskComment}${comment.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-flex align-items-center text-dark text-decoration-none"
                        >
                          <Icon name="paperclip" size={14} />
                          <span className="mx-2">{comment.attachment} </span>
                        </a>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="text-center text-muted py-3">
                لا توجد ردود حتى الآن
              </div>
            )}
          </div>
        )}
      </div>
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        style={{ direction: getDir(getCurrentLangFromRedux()) }}
        centered
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="fw-bold text-danger"
          >
            <div className="d-flex align-items-center mx-md-3 mx-1">
              <div
                className="mx-2 d-flex justify-content-center align-items-center"
                style={{
                  height: 32,
                  width: 32,
                }}
              >
                <img
                  src="/assets/images/deleteicon.png"
                  width={20}
                  height={20}
                  alt=""
                />
              </div>
              <div className="text-dark d-flex align-content-center">
                <p
                  className="my-0 "
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "rgb(12, 87, 76)",
                  }}
                >
                  {" "}
                  {Lang.deleteTitle}
                </p>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <div className=" d-flex flex-column  align-items-center justify-content-center">
          <img src="/assets/images/fi-br-info.png" />
          <div className="my-2">{Lang.deleteMessage}</div>
          <div className="d-flex justify-content-center flex-wrap w-100 my-3">
            <Button
              containerStyle={"col-3 mx-2"}
              content={getDir(getCurrentLangFromRedux()) == "rtl" ? "لا" : "No"}
              onClick={() => setShowDeleteModal(false)}
            />
            <Button
              containerStyle={"col-3 mx-2 "}
              content={
                getDir(getCurrentLangFromRedux()) == "rtl" ? "نعم" : "Yes"
              }
              buttonStyleType={"solid"}
              disable={deleting}
              onClick={handleDelete}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AssignmentCard;
